import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "radio", "swatch", "customRadio", "customSwatch", "colorInput", "rainbow"]

    connect() {
        // Initial setup if needed
    }

    select(event) {
        // Let the radio selection happen naturally if clicked on input, 
        // otherwise if clicked on label/div, the label wraps it so it works.

        // Update visual state for all
        this.updateVisualState()
    }

    selectCustom(event) {
        if (event.target !== this.colorInputTarget) {
            event.preventDefault()
            this.colorInputTarget.click()
        }
    }

    updateCustomColor(event) {
        const color = this.colorInputTarget.value

        // Update the visual swatch
        this.customSwatchTarget.style.backgroundColor = color
        this.customSwatchTarget.style.borderColor = color

        // Hide rainbow fallback
        if (this.rainbowTarget) {
            this.rainbowTarget.classList.add("hidden")
        }

        // Show the pencil icon or check icon - actually we just want check icon if selected
        // But we also want the pencil hint when not selected? 
        // No, standard behavior: showing the color is enough.

        // Update the actual radio value key to be submitted
        this.customRadioTarget.value = color
        this.customRadioTarget.checked = true

        this.updateVisualState()
    }

    updateVisualState() {
        // Handle standard presets
        this.radioTargets.forEach(radio => {
            const wrapper = radio.closest("label").querySelector(".check-icon")
            if (wrapper) {
                if (radio.checked) {
                    wrapper.classList.remove("hidden")
                    wrapper.classList.add("flex")
                } else {
                    wrapper.classList.add("hidden")
                    wrapper.classList.remove("flex")
                }
            }
        })

        // Handle custom
        if (this.hasCustomRadioTarget && this.hasCustomSwatchTarget) {
            const wrapper = this.customSwatchTarget.querySelector(".check-icon")
            const pencil = this.customSwatchTarget.querySelector(".ti-pencil")?.parentElement

            if (this.customRadioTarget.checked) {
                wrapper.classList.remove("hidden")
                wrapper.classList.add("flex")
                if (pencil) pencil.classList.add("hidden")

                // Ensure rainbow is hidden if we have a color
                if (this.customRadioTarget.value && this.rainbowTarget) {
                    this.rainbowTarget.classList.add("hidden")
                }
            } else {
                wrapper.classList.add("hidden")
                wrapper.classList.remove("flex")
                if (pencil) pencil.classList.remove("hidden")
            }
        }
    }
}
